module.exports = __webpack_public_path__ + "img/register-bg.03505ff9.svg";